<template lang="pug">
.award-container(v-if="awardList.length>0")
  .award-title
    span 完成
    span.red-word {{awardTotalList.length}}
    span 个不同业务下单，最高得
    .task-middle-block-line-award
      img.title-img(src="https://m.hellobike.com/resource/helloyun/08345/qSbGFKFPtD.png")
      span +{{totalAmountSum}}
  .award-introduce 单车 | 助力车 | 顺风车 | 打车 | 租车 | 话费 | 火车票 | 加油/充电 | 送货
  .award-block
    .award-list(v-for="(item,index) in awardTotalList")
      .award-main(:class="getBlock(item)")
        .award-mian-total +{{item.totalAmount}}
        img.total-img(v-if="item.offerStatus !== 3&&!item.isMax" src="https://m.hellobike.com/resource/helloyun/08345/qSbGFKFPtD.png")
        img.red-img(v-else-if="item.offerStatus !== 3&&item.isMax" src="https://m.hellobike.com/resource/gallery/61/rPtsEkMu_Group%201707482234.png?x-oss-process=image/quality,q_80")
        img.total-img(v-else="item.offerStatus === 3" src="https://m.hellobike.com/resource/gallery/61/dILjfmOJg4.png?x-oss-process=image/quality,q_80")
      .award-cricle(:style="item.offerStatus!==3?'':'background: #FFC770'")
        .award-line(:style="lineStyle(index)" v-if="index!==awardTotalList.length-1")
      .award-word(:class="item.offerStatus===3?'award-gary-word':''") {{item.offerStatus ===3?'已领取':`完成${index+1}个业务`}}
</template>
<script>
export default {
  props: {
    awardList: {
      type: Array,
      default() {
        return [
        ];
      },
    },
  },
  data() {
    return {
    };
  },
  computed: {
    awardTotalList() {
      if (this.awardList && this.awardList.length > 0) {
        const awardTotalList = this.awardList[0].stageOffers;

        // 找到状态为3且totalAmount最大的项
        const maxTotalAmount = Math.max(...awardTotalList.filter((item) => item.offerStatus !== 3).map((item) => item.totalAmount));
        let maxItemMarked = false;

        // 标记每个项
        return awardTotalList.map((item) => {
          if (item.offerStatus !== 3 && item.totalAmount === maxTotalAmount && !maxItemMarked) {
            maxItemMarked = true;
            return {
              ...item,
              isMax: true,
            };
          }
          return {
            ...item,
            isMax: false,
          };
        });
      }
      return [];
    },
    totalAmountSum() {
      return this.awardTotalList.reduce((sum, offer) => sum + (offer.totalAmount || 0), 0);
    },
  },
  mounted() {
  },
  methods: {
    lineStyle(index) {
      if (this.awardTotalList[index].offerStatus === 3
        && this.awardTotalList[index + 1]
        && this.awardTotalList[index + 1].offerStatus === 3) {
        return 'background: #FFC770';
      }
      return '';
    },
    getBlock(item) {
      if (item.offerStatus !== 3 && item.isMax) {
        return 'award-big-block';
      }
      if (item.offerStatus === 3) {
        return 'award-gary-block';
      }
      return '';
    },
  },
};
</script>
<style lang="less" scoped>
.award-container {
  background: #fff;
  border-radius: 0.2rem;
  border: 0.005rem solid #fff;
  padding-bottom: 0.12rem;

  .award-title {
    display: flex;
    //垂直居中
    align-items: center;

    padding: 0.12rem 0 0 0.15rem;
    font-weight: 500;
    font-size: 0.14rem;

    .red-word {
      color: #ff5526;
      font-family: "DIN Alternate Bold", sans-serif;
      font-size: 0.16rem;
      font-weight: 700;
      line-height: 0.23rem;
      margin: 0 0.02rem;
    }

    .task-middle-block-line-award {
      margin-top: 0.03rem;
      height: 0.15rem;
      background: #ffefd6;
      border-radius: 0.5rem;
      margin-left: 0.08rem;
      color: #fa4614;
      font-weight: 500;
      font-size: 0.12rem;
      line-height: 0.14rem;
      display: flex;
      padding-right: 0.03rem;

      img {
        width: 0.14rem;
        height: 0.14rem;
        border-radius: 50%;
      }
    }
  }

  .award-introduce {
    padding-left: 0.15rem;
    font-family: PingFang SC;
    font-size: 0.1rem;
    font-weight: 400;
    line-height: 0.14rem;
    color: #879099;
    margin-top: 0.01rem;
  }

  .award-block {
    overflow-x: scroll;
    margin-top: 0.11rem;
    display: flex;
    padding-left: 0.18rem;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }

    .award-list {
      margin-right: 0.4rem;

      .award-main {
        width: 0.44rem;
        height: 0.47rem;
        background: #fcf8e8;
        border-radius: 0.05rem;

        .award-mian-total {
          padding-top: 0.06rem;
          text-align: center;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-size: 0.11rem;
          font-weight: 500;
          line-height: 0.12rem;
          color: #242729;
        }

        img.total-img {
          margin: 0.06rem auto;
          width: 0.16rem;
          height: 0.16rem;
          display: block;
        }

        img.red-img {
          margin: 0 auto;
          width: 0.16rem;
          height: 0.192rem;
          display: block;
        }
      }

      .award-big-block {
        background: linear-gradient(180deg, #FFECB9 0%, #FFD972 100%);

        .award-mian-total {
          color: #ff5c0a;
        }
      }

      .award-gary-block {
        background: #f0f3f5;
        color: #bcc4cc;
      }

      .award-cricle {
        width: 0.06rem;
        height: 0.06rem;
        border: 0.01rem solid #fff;
        background: #d3dae0;
        border-radius: 50%;
        margin: 0.03rem auto;
        position: relative;

        .award-line {
          position: absolute;
          width: 0.84rem;
          height: 0.02rem;
          background: #d3dae0;
          bottom: 0.01rem;
          left: 0.05rem;
        }
      }

      .award-word {
        width: 0.505rem;
        margin-top: 0.04rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.09rem;
        font-weight: 400;
        line-height: 0.126rem;
        text-align: center;
      }

      .award-gary-word {
        color: #879099;
      }
    }
  }
}
</style>
